module.exports = __webpack_public_path__ + "img/istockphoto-533714204-612x612.f58f92c2.webp";